export default {
    'diagram6-3a1': {
        'diagram-number': '6.',
        'elements': {
            'one': 'Early childhood teaching focuses on developing the “left brain” skills of reading, writing and ‘rithmatic',
            'two': 'But scientists have recorded striking changes in the left-hemispheres of children who have had only a single year of violin ',
            'three': 'Music may be every bit as important educationally as reading or writing',
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a1/diagram6/i18n/en.js